export const locations = {
  metro: {
    cadet: {
      name: "Métro Cadet",
      line: "7",
      distance: "50 m",
      walkingTime: "1 minute",
    },
  },
  stations: {
    gareNord: {
      name: "Gare du Nord",
      lines: ["RER B", "RER D", "Transilien", "Métro 4", "Métro 5"],
      distance: "1,2 km",
      walkingTime: "15 minutes",
    },
    gareEst: {
      name: "Gare de l'Est",
      lines: ["Transilien", "Métro 4", "Métro 5", "Métro 7"],
      distance: "1 km",
      walkingTime: "12 minutes",
    },
    gareSaintLazare: {
      name: "Gare Saint-Lazare",
      lines: ["Transilien", "Métro 3", "Métro 12", "Métro 13", "Métro 14"],
      distance: "1,8 km",
      walkingTime: "20 minutes",
    },
  },
  districts: {
    main: "9e arrondissement",
    nearby: ["8e", "9e", "10e"],
  },
  address: {
    street: "5 rue Marguerite de Rochechouart",
    postal: "75009",
    city: "Paris",
    coordinates: {
      lat: 48.8768224,
      lng: 2.3443894,
    },
  },
};
